export const IsRestrictedECCContactDetails = true;
